export default __webpack_public_path__ + "static/media/hero-h.30cf82c1.svg";